import map from 'lodash/map'

const requiredFields = {
  space: {
    title: 'Space',
    rule: '',
  },
  schedule: {
    title: 'Schedule',
    rule: '',
  },
  startTime: {
    title: 'Start Time',
    rule: '',
  },
  endTime: {
    title: 'End Time',
    rule: '',
  },
  guests: {
    title: 'Guests',
    rule: '',
  },
  amount: {
    title: 'Amount',
    rule: '',
  },
}

const validator = value => {
  const errors = {}

  map(requiredFields, ({ max, min, title }, field) => {
    if (!value[field]) {
      errors[field] = `${title} field is required`
    } else if (value[field].length > max) {
      errors[field] = `Field reached ${max} characters`
    } else if (value[field].length < min) {
      errors[field] = `Field requires a minimum of ${min} characters`
    }
  })

  return errors
}

export default validator
